"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../../../login/login-connector"));
var _rowConfig = _interopRequireDefault(require("../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../core/label"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _competitionHelp = _interopRequireDefault(require("./competition-help"));
var _cancelCompetition = _interopRequireDefault(require("./cancel-competition"));
var _refundLateFees = _interopRequireDefault(require("./refund-late-fees"));
var _CompetitionStatus = _interopRequireDefault(require("./CompetitionStatus"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_competitionHelp.default, null));
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Organising Club(s)");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Competition");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Sub-Title");
var _ref5 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Short Name");
var _ref6 = /*#__PURE__*/_react.default.createElement(_label.default, null, " Organiser Name");
var _ref7 = /*#__PURE__*/_react.default.createElement(_label.default, null, " Contact Email");
var _ref8 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref9 = /*#__PURE__*/_react.default.createElement("p", null, " Notes for home page:");
const SetUpCompetition = (0, _loginConnector.default)(class extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onUpdateCompetition", (fieldname, value) => {
      this.props.onUpdateCompetition(this.props.competition.id, fieldname, value);
    });
    _defineProperty(this, "_setFreeCode", value => {
      this.props.onSetFreeCode(this.props.competition.id, value);
    });
  }
  render() {
    const comp = this.props.competition;
    if (!comp.isAdministratedByUser) return null;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_CompetitionStatus.default, {
      competition: comp
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: 24
      }
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6,
      xl: 6
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3,
        lg: 5
      }, {
        sm: 8,
        md: 6,
        lg: 7
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, comp.organisingClubName)), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      preparedForEdit: true,
      type: "text",
      name: "competitionName",
      value: comp.competitionName,
      maxLength: 100,
      onChange: this._onUpdateCompetition.bind(this, 'competitionName'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      preparedForEdit: true,
      type: "text",
      name: "subTitle",
      value: comp.subTitle,
      maxLength: 100,
      onChange: this._onUpdateCompetition.bind(this, 'subTitle')
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref5, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: this.props.userIsSystemAdmin,
      preparedForEdit: true,
      type: "text",
      name: "shortName",
      value: comp.shortName,
      maxLength: 13,
      onChange: this._onUpdateCompetition.bind(this, 'shortName'),
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref6, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "text",
      name: "organiserName",
      value: comp.organiserName,
      maxLength: 100,
      onChange: this._onUpdateCompetition.bind(this, 'organiserName')
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref7, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "email",
      name: "organiserEmail",
      value: comp.organiserEmail,
      maxLength: 100,
      onChange: this._onUpdateCompetition.bind(this, 'organiserEmail')
    })))), _ref8, /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "onDayEntriesAccepted",
      checked: comp.onDayEntriesAccepted,
      onChange: this._onUpdateCompetition.bind(this, 'onDayEntriesAccepted'),
      label: "On the Day Entries Accepted"
    }), /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "useFreeCode",
      checked: comp.useFreeCode,
      onChange: this._setFreeCode,
      label: "Use Organiser's Free Code (intended for selection, pan-celtic etc)"
    }), !comp.useFreeCode ? null : /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      name: "displayFreeCode",
      checked: comp.displayFreeCode,
      onChange: this._onUpdateCompetition.bind(this, 'displayFreeCode'),
      label: "Show Free Code on Home Page and Start List"
    }))), /*#__PURE__*/_react.default.createElement(_col.default, {
      lg: 6,
      xl: 6
    }, _ref9, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "RichText",
      name: "displayedNotes",
      maxLength: 2000,
      value: comp.displayedNotes || {
        __html: ''
      },
      onChange: this._onUpdateCompetition.bind(this, 'displayedNotes')
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_cancelCompetition.default, {
      competition: comp
    }), /*#__PURE__*/_react.default.createElement(_refundLateFees.default, {
      competition: comp
    }))));
  }
});

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref10 = _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
  id: true,
  competitionName: true,
  shortName: true,
  subTitle: true,
  organiserName: true,
  organiserEmail: true,
  organisingClubName: true,
  displayedNotes: true,
  isAdministratedByUser: true,
  useFreeCode: true,
  displayFreeCode: true,
  onDayEntriesAccepted: true
}, _cancelCompetition.default.partialQueries.Competition), _refundLateFees.default.partialQueries.Competition), _CompetitionStatus.default.partialQueries.Competition);
var _default = exports.default = (0, _reactBicycle.connect)(SetUpCompetition, props => ({
  userIsSystemAdmin: true,
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref10
}), (client, props) => ({
  onUpdateCompetition(id, field, value) {
    return client.update('Competition.set', {
      id,
      field,
      value
    });
  },
  onSetFreeCode(competitionID, value) {
    return client.update('Competition.setFreeCode', {
      competitionID,
      value
    });
  }
}));